import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import SidebarItem from "components/SidebarItem";
import CommodityShowSmall from "components/CommodityShowSmall";
import incidentCausesDuck from "data-handler/ducks/incidentCauses";

export default function IncidentItem({
  currentStoreData,
  store,
  ...extraProps
}) {
  const params = useParams();
  const incidentCauses = useSelector(incidentCausesDuck.getList);
  const storeCauses = store?.causes || [];
  const otherCause = store?.meta?.other_cause || "";
  const causes = storeCauses.map((cause) =>
    incidentCauses.find((e) => e.id === cause)
  );

  const title = (
    <>
      {causes?.map((cause) => {
        return (
          <span key={cause?.id} className="reason-list__item">
            {cause?.name}
          </span>
        );
      })}
      {storeCauses.length === 0 && !otherCause && (
        <FormattedMessage id="Common.noReason" defaultMessage="No reason" />
      )}
    </>
  );

  return (
    <SidebarItem
      {...extraProps}
      store={store}
      selected={
        currentStoreData && currentStoreData.client_id === store.client_id
      }
      id={store.client_id}
      key={store.client_id}
      title={title}
      subTitle={otherCause}
      to={`/school/${params.schoolId}/deliveries/${store.client_id}`}
      type={store.type}
    >
      <CommodityShowSmall commodities={store?.stock_events} />
    </SidebarItem>
  );
}
